export const FORMATS = {
  DATE: 'MMMM D, YYYY h:mm:ss A',
  MONTH: 'MMMM',
};
